module.exports = __webpack_public_path__ + "static/media/31JFA3.319f6a06.jpg";